import { FetchCustomerOrders } from '../../graphql/queries';
import Logger from '../../util/Logger';

export function getOrdersHistory(client, userId, ordersFrom, amountPerRequest, callback) {
  client.query({
    query: FetchCustomerOrders,
    variables: { id: userId, ordersFrom: (ordersFrom), ordersLimit: amountPerRequest },
  })
  .then(resp => {
    callback(resp);
  })
  .catch(err => {
    Logger.log(err);
  });
}


// WEBPACK FOOTER //
// ./src/redux/actions/orderHistoryActions.js